import { z } from 'zod'
import { SimpleTimestampSchema } from '../timestamp'

export const FeedbackSchema = z.object({
  timestamp: SimpleTimestampSchema,
  comment: z.string(),
})
export type Feedback = z.infer<typeof FeedbackSchema>
